import React, { useState, useEffect } from 'react'

import styled from 'styled-components'

import { devices, colors } from '../Common'


const IEModal = () => {
    const [showModal, setShowModal] = useState(false)

    useEffect(() => {
        setTimeout(() => setShowModal(true), 500)
    })

    return (
        <MuseumModal>
            <Modal show={showModal}>
                <ModalContent show={showModal}>
                    <Title>Please upgrade to a modern browser for the best experience</Title>
                    <HR />
                    <Info>
                        <p>We recommend using <a href='https://www.google.com/chrome/' rel='noopener noreferrer'>Google Chrome</a>, <a href='https://www.mozilla.org/firefox/new/' rel='noopener noreferrer' target='_blank'>Firefox</a>, or Safari</p>
                    </Info>
                </ModalContent>
                <Close title='Close (Esc)' onClick={() => setShowModal(false)} />
            </Modal>
            <ModalBackground show={showModal} onClick={() => setShowModal(false)}/>
        </MuseumModal>
    )
}

const MuseumModal = styled.div`
    height: 100vh;
    width: 100vw;
`

const ModalBackground = styled.div`
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 10000;
    opacity: ${props => props.show ? 1 : 0};
    visibility: ${props => props.show ? 'visible' : 'hidden'};
    background: rgba(${colors.black}, 0.65);
    transition: all 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
`

const Modal = styled.div`
    visibility: ${props => props.show ? 'visible' : 'hidden'};
    backface-visibility: ${props => props.show ? 'visible' : 'hidden'};
    transform: ${props => props.show ? 'translateX(-50%) translateY(-50%)' : 'translateX(-50%) translateY(-70%)'};
    transition: transform 0.3s;
    position: fixed;
    top: 50%;
    left: 50%;
    width: 50%;
    max-width: 1000px;
    min-width: 320px;
    height: auto;
    z-index: 1000000;
    color: ${colors.black};
    display: flex;
    justify-content: center;
    align-items: center;

    @media ${devices.tablet} and (orientation: landscape) {
        width: 100vw;
        max-width: 100vw;
        max-height: 100vh;
    }
`

const ModalContent = styled.div`
    padding: 0 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 1000000;
`

const Title = styled.div`
    font-size: 25px;
    text-align: center;
    max-width: 400px;
    font-weight: 400;
    letter-spacing: 1px;
    @media ${devices.mobile} {
        font-size: 21px;
    }
`

const Close = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    height: 50px;
    width: 50px;
    z-index: 10000000000;

    &:before, &:after {
        content: '';
        position: absolute;
        width: 30px;
        height: 2px;
        background-color: white;
        top: 25px;
        right: 10px;
    }

    &:before{
        transform: rotate(45deg);
    }
    &:after{
        transform: rotate(-45deg);
    }
`

const Info = styled.div`
    text-align: center;
    font-size: 19px;
    margin-bottom: 35px;
    font-weight: 300;
    letter-spacing: 0.8px;
    max-width: 630px;

    a {
        color: white !important;
    }
`

const HR = styled.div`
    border-bottom: 2px solid white;
    margin: 30px 0;
    width: 15%;
    @media ${devices.mobile} {
        margin: 25px 0;
    }
`

export default IEModal
